class RoundsModelModel {

  private _id: any;
  private _name: any;
  private _startdate: any;
  private _enddate: any;
  private _withdrawal_end_date: any;
  private _date: any;
  private _details: any;
  private _drive_id: any;

  private _cse_seats: any;
  private _ece_seats: any;
  private _ai_seats: any;
  private _cse_cutoff: any;
  private _ece_cutoff: any;
  private _ai_cutoff: any;
  private _cse_count: any;
  private _ece_count: any;
  private _ai_count: any;
  private _allocation_type: any;
  private _cse_gate_min: any;
  private _cse_gate_max: any;
  private _ece_gate_min: any;
  private _ece_gate_max: any;
  private _ai_gate_min: any;
  private _ai_gate_max: any;
  private _offer_letter_template_name: any;
  private _extra_data: any;
  private _prev_round_id: any;
  private _prev_round_mode: any;
  private _prev_statuses: any;

  // B.Tech / IM.Tech fields
  private _btech_cse_seats: any;
  private _btech_ece_seats: any;
  private _btech_ai_seats: any;
  private _imtech_cse_seats: any;
  private _imtech_ece_seats: any;
  private _btech_cse_count: any;
  private _btech_ece_count: any;
  private _btech_ai_count: any;
  private _imtech_cse_count: any;
  private _imtech_ece_count: any;
  private _btech_cse_cutoff: any;
  private _btech_ece_cutoff: any;
  private _btech_ai_cutoff: any;
  private _imtech_cse_cutoff: any;
  private _imtech_ece_cutoff: any;

  private _mtech_online_cse_seats: any;
  private _mtech_online_cse_remaining: any;
  private _mtech_online_cse_last_updated: any;
  private _mtech_online_ece_seats: any;
  private _mtech_online_ece_remaining: any;
  private _mtech_online_ece_last_updated: any;
  private _mtech_online_aids_seats: any;
  private _mtech_online_aids_remaining: any;
  private _mtech_online_aids_last_updated: any;

  constructor(data: any) {
    this._id = data["id"];
    this._name = data["name"];
    this._startdate = data["startdate"];
    this._enddate = data["enddate"];
    this._withdrawal_end_date = data["withdrawal_end_date"];
    this._date = data["date"];
    this._details = data["details"];
    this._drive_id = data["drive_id"];
    this._cse_seats = data["cse_seats"];
    this._ece_seats = data["ece_seats"];
    this._ai_seats = data["ai_seats"];
    this._cse_cutoff = data["cse_cutoff"];
    this._ece_cutoff = data["ece_cutoff"];
    this._ai_cutoff = data["ai_cutoff"];
    this._cse_count = data["cse_count"];
    this._ece_count = data["ece_count"];
    this._ai_count = data["ai_count"];
    this._allocation_type = data["allocation_type"];
    this._cse_gate_min = data["cse_gate_min"];
    this._cse_gate_max = data["cse_gate_max"];
    this._ece_gate_min = data["ece_gate_min"];
    this._ece_gate_max = data["ece_gate_max"];
    this._ai_gate_min = data["ai_gate_min"];
    this._ai_gate_max = data["ai_gate_max"];
    this._offer_letter_template_name = data["offer_letter_template_name"];
    this._extra_data = data["extra_data"];
    this._prev_round_id = data["prev_round_id"];
    this._prev_round_mode = data["prev_round_mode"];
    this._prev_statuses = data["prev_statuses"];

    this._btech_cse_seats = data["btech_cse_seats"];
    this._btech_ece_seats = data["btech_ece_seats"];
    this._btech_ai_seats = data["btech_ai_seats"];
    this._imtech_cse_seats = data["imtech_cse_seats"];
    this._imtech_ece_seats = data["imtech_ece_seats"];
    this._btech_cse_count = data["btech_cse_count"];
    this._btech_ece_count = data["btech_ece_count"];
    this._btech_ai_count = data["btech_ai_count"];
    this._imtech_cse_count = data["imtech_cse_count"];
    this._imtech_ece_count = data["imtech_ece_count"];
    this._btech_cse_cutoff = data["btech_cse_cutoff"];
    this._btech_ece_cutoff = data["btech_ece_cutoff"];
    this._btech_ai_cutoff = data["btech_ai_cutoff"];
    this._imtech_cse_cutoff = data["imtech_cse_cutoff"];
    this._imtech_ece_cutoff = data["imtech_ece_cutoff"];

    this._mtech_online_cse_seats = data["mtech_online_cse_seats"];
    this._mtech_online_cse_remaining = data["mtech_online_cse_remaining"];
    this._mtech_online_cse_last_updated = data["mtech_online_cse_last_updated"];
    this._mtech_online_ece_seats = data["mtech_online_ece_seats"];
    this._mtech_online_ece_remaining = data["mtech_online_ece_remaining"];
    this._mtech_online_ece_last_updated = data["mtech_online_ece_last_updated"];
    this._mtech_online_aids_seats = data["mtech_online_aids_seats"];
    this._mtech_online_aids_remaining = data["mtech_online_aids_remaining"];
    this._mtech_online_aids_last_updated = data["mtech_online_aids_last_updated"];
  }

  public getId(): any { return this._id; }
  public setId(value: any) { this._id = value; }

  public getName(): any { return this._name; }
  public setName(value: any) { this._name = value; }

  public getStartdate(): any { return this._startdate; }
  public setStartdate(value: any) { this._startdate = value; }

  public getEnddate(): any { return this._enddate; }
  public setEnddate(value: any) { this._enddate = value; }

  public getWithdrawal_end_date(): any { return this._withdrawal_end_date; }
  public setWithdrawal_end_date(value: any) { this._withdrawal_end_date = value; }

  public getDate(): any { return this._date; }
  public setDate(value: any) { this._date = value; }

  public getDetails(): any { return this._details; }
  public setDetails(value: any) { this._details = value; }

  public getDrive_id(): any { return this._drive_id; }
  public setDrive_id(value: any) { this._drive_id = value; }

  public getCse_seats(): any { return this._cse_seats; }
  public setCse_seats(value: any) { this._cse_seats = value; }

  public getEce_seats(): any { return this._ece_seats; }
  public setEce_seats(value: any) { this._ece_seats = value; }

  public getAi_seats(): any { return this._ai_seats; }
  public setAi_seats(value: any) { this._ai_seats = value; }

  public getCse_cutoff(): any { return this._cse_cutoff; }
  public setCse_cutoff(value: any) { this._cse_cutoff = value; }

  public getEce_cutoff(): any { return this._ece_cutoff; }
  public setEce_cutoff(value: any) { this._ece_cutoff = value; }

  public getAi_cutoff(): any { return this._ai_cutoff; }
  public setAi_cutoff(value: any) { this._ai_cutoff = value; }

  public getCse_count(): any { return this._cse_count; }
  public setCse_count(value: any) { this._cse_count = value; }

  public getEce_count(): any { return this._ece_count; }
  public setEce_count(value: any) { this._ece_count = value; }

  public getAi_count(): any { return this._ai_count; }
  public setAi_count(value: any) { this._ai_count = value; }

  public getAllocation_type(): any { return this._allocation_type; }
  public setAllocation_type(value: any) { this._allocation_type = value; }

  public getCse_gate_min(): any { return this._cse_gate_min; }
  public setCse_gate_min(value: any) { this._cse_gate_min = value; }

  public getCse_gate_max(): any { return this._cse_gate_max; }
  public setCse_gate_max(value: any) { this._cse_gate_max = value; }

  public getEce_gate_min(): any { return this._ece_gate_min; }
  public setEce_gate_min(value: any) { this._ece_gate_min = value; }

  public getEce_gate_max(): any { return this._ece_gate_max; }
  public setEce_gate_max(value: any) { this._ece_gate_max = value; }

  public getAi_gate_min(): any { return this._ai_gate_min; }
  public setAi_gate_min(value: any) { this._ai_gate_min = value; }

  public getAi_gate_max(): any { return this._ai_gate_max; }
  public setAi_gate_max(value: any) { this._ai_gate_max = value; }

  public getOffer_letter_template_name(): any { return this._offer_letter_template_name; }
  public setOffer_letter_template_name(value: any) { this._offer_letter_template_name = value; }

  public getExtra_data(): any { return this._extra_data; }
  public setExtra_data(value: any) { this._extra_data = value; }

  public getPrev_round_id(): any { return this._prev_round_id; }
  public setPrev_round_id(value: any) { this._prev_round_id = value; }

  public getPrev_round_mode(): any { return this._prev_round_mode; }
  public setPrev_round_mode(value: any) { this._prev_round_mode = value; }

  public getPrev_statuses(): any { return this._prev_statuses; }
  public setPrev_statuses(value: any) { this._prev_statuses = value; }

  // B.Tech / IM.Tech getters & setters
  public getBtech_cse_seats(): any { return this._btech_cse_seats; }
  public setBtech_cse_seats(v: any) { this._btech_cse_seats = v; }
  public getBtech_ece_seats(): any { return this._btech_ece_seats; }
  public setBtech_ece_seats(v: any) { this._btech_ece_seats = v; }
  public getBtech_ai_seats(): any { return this._btech_ai_seats; }
  public setBtech_ai_seats(v: any) { this._btech_ai_seats = v; }
  public getImtech_cse_seats(): any { return this._imtech_cse_seats; }
  public setImtech_cse_seats(v: any) { this._imtech_cse_seats = v; }
  public getImtech_ece_seats(): any { return this._imtech_ece_seats; }
  public setImtech_ece_seats(v: any) { this._imtech_ece_seats = v; }

  public getBtech_cse_count(): any { return this._btech_cse_count; }
  public setBtech_cse_count(v: any) { this._btech_cse_count = v; }
  public getBtech_ece_count(): any { return this._btech_ece_count; }
  public setBtech_ece_count(v: any) { this._btech_ece_count = v; }
  public getBtech_ai_count(): any { return this._btech_ai_count; }
  public setBtech_ai_count(v: any) { this._btech_ai_count = v; }
  public getImtech_cse_count(): any { return this._imtech_cse_count; }
  public setImtech_cse_count(v: any) { this._imtech_cse_count = v; }
  public getImtech_ece_count(): any { return this._imtech_ece_count; }
  public setImtech_ece_count(v: any) { this._imtech_ece_count = v; }

  public getBtech_cse_cutoff(): any { return this._btech_cse_cutoff; }
  public setBtech_cse_cutoff(v: any) { this._btech_cse_cutoff = v; }
  public getBtech_ece_cutoff(): any { return this._btech_ece_cutoff; }
  public setBtech_ece_cutoff(v: any) { this._btech_ece_cutoff = v; }
  public getBtech_ai_cutoff(): any { return this._btech_ai_cutoff; }
  public setBtech_ai_cutoff(v: any) { this._btech_ai_cutoff = v; }
  public getImtech_cse_cutoff(): any { return this._imtech_cse_cutoff; }
  public setImtech_cse_cutoff(v: any) { this._imtech_cse_cutoff = v; }
  public getImtech_ece_cutoff(): any { return this._imtech_ece_cutoff; }
  public setImtech_ece_cutoff(v: any) { this._imtech_ece_cutoff = v; }

  public getMtech_online_cse_seats(): any { return this._mtech_online_cse_seats; }
  public setMtech_online_cse_seats(v: any) { this._mtech_online_cse_seats = v; }
  public getMtech_online_cse_remaining(): any { return this._mtech_online_cse_remaining; }
  public setMtech_online_cse_remaining(v: any) { this._mtech_online_cse_remaining = v; }
  public getMtech_online_cse_last_updated(): any { return this._mtech_online_cse_last_updated; }
  public setMtech_online_cse_last_updated(v: any) { this._mtech_online_cse_last_updated = v; }

  public getMtech_online_ece_seats(): any { return this._mtech_online_ece_seats; }
  public setMtech_online_ece_seats(v: any) { this._mtech_online_ece_seats = v; }
  public getMtech_online_ece_remaining(): any { return this._mtech_online_ece_remaining; }
  public setMtech_online_ece_remaining(v: any) { this._mtech_online_ece_remaining = v; }
  public getMtech_online_ece_last_updated(): any { return this._mtech_online_ece_last_updated; }
  public setMtech_online_ece_last_updated(v: any) { this._mtech_online_ece_last_updated = v; }

  public getMtech_online_aids_seats(): any { return this._mtech_online_aids_seats; }
  public setMtech_online_aids_seats(v: any) { this._mtech_online_aids_seats = v; }
  public getMtech_online_aids_remaining(): any { return this._mtech_online_aids_remaining; }
  public setMtech_online_aids_remaining(v: any) { this._mtech_online_aids_remaining = v; }
  public getMtech_online_aids_last_updated(): any { return this._mtech_online_aids_last_updated; }
  public setMtech_online_aids_last_updated(v: any) { this._mtech_online_aids_last_updated = v; }

  public toJson(): any {
    return {
      "id": this._id,
      "name": this._name,
      "startdate": this._startdate,
      "enddate": this._enddate,
      "withdrawal_end_date": this._withdrawal_end_date,
      "date": this._date,
      "details": this._details,
      "drive_id": this._drive_id,
      "cse_seats": this._cse_seats,
      "ece_seats": this._ece_seats,
      "ai_seats": this._ai_seats,
      "cse_cutoff": this._cse_cutoff,
      "ece_cutoff": this._ece_cutoff,
      "ai_cutoff": this._ai_cutoff,
      "cse_count": this._cse_count,
      "ece_count": this._ece_count,
      "ai_count": this._ai_count,
      "allocation_type": this._allocation_type,
      "cse_gate_min": this._cse_gate_min,
      "cse_gate_max": this._cse_gate_max,
      "ece_gate_min": this._ece_gate_min,
      "ece_gate_max": this._ece_gate_max,
      "ai_gate_min": this._ai_gate_min,
      "ai_gate_max": this._ai_gate_max,
      "offer_letter_template_name": this._offer_letter_template_name,
      "extra_data": this._extra_data,
      "prev_round_id": this._prev_round_id,
      "prev_round_mode": this._prev_round_mode,
      "prev_statuses": this._prev_statuses,
      "btech_cse_seats": this._btech_cse_seats,
      "btech_ece_seats": this._btech_ece_seats,
      "btech_ai_seats": this._btech_ai_seats,
      "imtech_cse_seats": this._imtech_cse_seats,
      "imtech_ece_seats": this._imtech_ece_seats,
      "btech_cse_count": this._btech_cse_count,
      "btech_ece_count": this._btech_ece_count,
      "btech_ai_count": this._btech_ai_count,
      "imtech_cse_count": this._imtech_cse_count,
      "imtech_ece_count": this._imtech_ece_count,
      "btech_cse_cutoff": this._btech_cse_cutoff,
      "btech_ece_cutoff": this._btech_ece_cutoff,
      "btech_ai_cutoff": this._btech_ai_cutoff,
      "imtech_cse_cutoff": this._imtech_cse_cutoff,
      "imtech_ece_cutoff": this._imtech_ece_cutoff,
      "mtech_online_cse_seats": this._mtech_online_cse_seats,
      "mtech_online_cse_remaining": this._mtech_online_cse_remaining,
      "mtech_online_cse_last_updated": this._mtech_online_cse_last_updated,
      "mtech_online_ece_seats": this._mtech_online_ece_seats,
      "mtech_online_ece_remaining": this._mtech_online_ece_remaining,
      "mtech_online_ece_last_updated": this._mtech_online_ece_last_updated,
      "mtech_online_aids_seats": this._mtech_online_aids_seats,
      "mtech_online_aids_remaining": this._mtech_online_aids_remaining,
      "mtech_online_aids_last_updated": this._mtech_online_aids_last_updated,
    };
  }

  public static fromJson(json: any): RoundsModelModel {
    return new RoundsModelModel(json);
  }
}

export default RoundsModelModel;
